import { CSSObject, styled } from '@mui/material';

import { AppLayout } from '@/dmdrive/core/constants/layout';

export const LoaderWrapper = styled('div')({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const TopicRoot = styled('div')(({ layout }: { layout: AppLayout }) => {
  const styles: CSSObject = {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
  };

  if (layout === AppLayout.Mobile) {
    styles.flexDirection = 'column';
  } else {
    styles.alignItems = 'stretch';
  }

  return styles;
});

export const MobileControlBar = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});
